<template>
<div>
  <GridLocal name="filterGridProduct" ref="filterGridProduct" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"  v-bind:databound="dataBound"></GridLocal>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import GridLocal from '@/components/GridLocal.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'Product',
  extends: BaseFilter,
  components: {
    GridLocal
  },
  data() {
    return {
      fieldName: 'product_id',
      fieldLabel: 'Produto',
      gridRef: 'filterGridProduct',
      preload: [{
        field: 'prodaggreg_id',
        api: 'prodagregs/lst'
      }],
      schemaModelFields: {},
      url: 'products',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'sku',
        title: 'Sku'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'prodaggreg_id',
        title: 'ProdAgreg',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductFilter.vue?7f6a8b72